import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import { getBusinessEmailServiceURL } from '../../../../../../utils/urls';
import { NOTIFICATION_TEMPLATE_NAME } from './DomainSelect.constants';
export function submitDomainInformation(_x, _x2) {
  return _submitDomainInformation.apply(this, arguments);
}

function _submitDomainInformation() {
  _submitDomainInformation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
    var businessType, businessId, domainName, domainType, url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            businessType = _ref.type, businessId = _ref.id;
            domainName = _ref2.domainName, domainType = _ref2.domainType;
            url = getBusinessEmailServiceURL(businessType, businessId);
            return _context.abrupt("return", axios.post(url, {
              domain_name: domainName,
              domain_type: domainType,
              email_type: NOTIFICATION_TEMPLATE_NAME
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _submitDomainInformation.apply(this, arguments);
}